import { getData, postData } from '../../../utils/fetch-api-util';
import { FilterTTBFraudType, SortTTBFraudType, TTBFraudType } from '../../../types/tryThenBuyFraud';

export interface TTBFraudRequestParams extends FilterTTBFraudType, SortTTBFraudType {
  take?: number;
  page?: number;
}

export interface TTBFraudTypeResponse {
  orders: TTBFraudType[];
  total: number;
}

export interface noteTTBFraudParams {
  ttbFraudId?: string;
  note?: string;
}
export interface configThresholdParams {
  type?: string;
  name?: string;
  totalOrder?: number;
}
export interface cancelTTBFraudParams {
  orderId?: string;
  reasonCancel?: string;
  userId?: string;
  isBlack?: boolean;
}
export interface ThresholdResponse {
  id?: string;
  name?: string;
  type: string;
  totalOrder?: number;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string;
  createdBy?: string;
  updatedBy?: string;
  deletedBy?: string;
}
interface SuccessResponse {
  success: boolean;
}

export const getTTBFraudListRepository = async (
  url: string,
  data?: TTBFraudRequestParams,
): Promise<TTBFraudTypeResponse> => {
  const response = await getData<TTBFraudRequestParams, TTBFraudTypeResponse>(url, data);
  return response.data;
};

export const getTTBFraudConfigThresholdListRepository = async (url: string): Promise<ThresholdResponse> => {
  const response = await getData<TTBFraudRequestParams, ThresholdResponse>(url);
  return response.data;
};

export const postConfigThresholdRepository = async (url: string, payload: configThresholdParams): Promise<void> => {
  await postData<configThresholdParams, SuccessResponse>(url, payload);
};

export const postNoteTTBFraudRepository = async (url: string, payload: noteTTBFraudParams): Promise<void> => {
  await postData<noteTTBFraudParams, SuccessResponse>(url, payload);
};

export const postCancelTTBFraudRepository = async (url: string, payload: cancelTTBFraudParams): Promise<void> => {
  await postData<cancelTTBFraudParams, SuccessResponse>(url, payload);
};
